<div class="d-flex justify-content-between align-items-center {{ panelClass}}">
    <div class="snackbar__data">{{ message | titlecase }}</div>
    <button mat-icon-button (click)="snackBarRef.dismiss()" class="btn btn-icon">
        <i class="fas fa-times txt--white txt--lg"></i>
    </button>
</div>
